/*
 * Translations for the admin usage-manager dashboard (#734 phase 3).
 */
export const ADMIN_USAGE_MANAGER_EN = {
  usageManager: 'Usage Manager',
  usageManagerSubtitle: 'Monitor usage limits and restrictions across all organisations',
  searchOrganisations: 'Search organisations...',
  clearFilters: 'Clear',
  showingOrganisations: 'Showing {shown} of {total} organisations',
  showingRestrictions: 'Showing {shown} of {total} restrictions',
  organisationUsageSubtitle: 'Team usage and per-user breakdown',
  openDetails: 'Open details',
  orgListFetchFailed: 'Could not load organisations',
  noOrganisations: 'No organisations',
  orgUsageFetchFailed: 'Could not load organisation usage',
  userUsageFetchFailed: 'Could not load user usage',
  restrictions: 'Restrictions',
  restrictionsFor: 'Restrictions for {scope}',
  restrictionsFetchFailed: 'Could not load restrictions',
  noRestrictions: 'No restrictions applicable',
  allOrganisations: 'All organisations',
  inherited: 'Inherited',
  paths: 'paths',
  limit: 'Limit',
  pooled: 'pooled',
  addRestriction: 'Add restriction',
  editRestrictionTitle: 'Edit restriction',
  target: 'Target',
  targetGlobal: 'Global',
  targetRole: 'Role',
  authority: 'Role name',
  poolAcrossUsers: 'Pool across users',
  resetDaysLabel: 'Reset days',
  filterPaths: 'Filter paths…',
  noPaths: 'No paths match',
  selected: 'selected',
  confirmDeleteRestriction: 'Delete this restriction?',
  confirmDeleteFeature: 'Delete this feature?',
  allRestrictions: 'All usage restrictions',
  seeAllRestrictions: 'See all',
  seeUsageRestrictions: 'See usage restrictions',
  filteredByFeature: 'Filtered by feature',
  feature: 'Feature',
  features: 'Features',
  selectFeatures: 'Search features...',
  combinedLimitHint: 'The limit applies as one shared quota across all selected features.',
  selectTier: 'Select a tier...',
  existingRuleConflict: 'A rule for this combination already exists. Edit it to make changes.',
  editExisting: 'Edit existing',
  restrictionConflictToast: 'A restriction for this feature at this scope already exists.',
  featureInUseToast: 'Cannot delete features used in restrictions',
  type: 'Type',
  platformWide: 'Platform-wide',
  kpiTotalOrgs: 'Organisations',
  kpiCritical: 'Critical',
  kpiCriticalDesc: '≥ 90%',
  kpiWarning: 'Warning',
  kpiWarningDesc: '50–89%',
  kpiHealthy: 'Healthy',
  kpiHealthyDesc: '< 50%',
  override: 'Override',
  overridden: 'Overridden',
  addOverrideTitle: 'Add override',
  editOverrideTitle: 'Edit override',
  catalog: 'Catalog',
  catalogSubtitle: 'Manage features and usage restrictions',
  manageOrga: 'Manage Organisation',
  manageUser: 'Manage User',
  usageRestrictions: 'Usage',
  featureRestrictions: 'Features',
  pathRestrictions: 'Paths',
  searchRestrictions: 'Search restrictions...',
  searchEndpoints: 'Search endpoints...',
  searchFeatures: 'Search features...',
  refresh: 'Refresh',
  method: 'Method',
  allMethods: 'All methods',
  endpoint: 'Endpoint',
  description: 'Description',
  name: 'Name',
  actions: 'Actions',
  createFeature: 'Create Feature',
  createFirstRestriction: 'Create first restriction',
  createFirstFeature: 'Create first feature',
  noFeaturesFound: 'No features found',
  loadingFeatures: 'Loading features...',
  noDescription: 'No description',
  noFeatureLinked: 'No feature linked',
  showingFeatures: 'Showing {shown} of {total} features'
}

export const ADMIN_USAGE_MANAGER_DE = {
  usageManager: 'Nutzungsverwaltung',
  usageManagerSubtitle: 'Nutzungslimits und Einschränkungen aller Organisationen überwachen',
  searchOrganisations: 'Organisationen suchen...',
  clearFilters: 'Zurücksetzen',
  showingOrganisations: 'Zeige {shown} von {total} Organisationen',
  showingRestrictions: 'Zeige {shown} von {total} Einschränkungen',
  organisationUsageSubtitle: 'Team-Nutzung und Aufschlüsselung nach Nutzer',
  openDetails: 'Details öffnen',
  orgListFetchFailed: 'Organisationen konnten nicht geladen werden',
  noOrganisations: 'Keine Organisationen',
  orgUsageFetchFailed: 'Organisationsnutzung konnte nicht geladen werden',
  userUsageFetchFailed: 'Nutzerdaten konnten nicht geladen werden',
  restrictions: 'Einschränkungen',
  restrictionsFor: 'Einschränkungen für {scope}',
  restrictionsFetchFailed: 'Einschränkungen konnten nicht geladen werden',
  noRestrictions: 'Keine Einschränkungen',
  allOrganisations: 'Alle Organisationen',
  inherited: 'Vererbt',
  paths: 'Pfade',
  limit: 'Limit',
  pooled: 'gepoolt',
  addRestriction: 'Einschränkung hinzufügen',
  editRestrictionTitle: 'Einschränkung bearbeiten',
  target: 'Ziel',
  targetGlobal: 'Global',
  targetRole: 'Rolle',
  authority: 'Rollenname',
  poolAcrossUsers: 'Über Nutzer hinweg poolen',
  resetDaysLabel: 'Reset-Tage',
  filterPaths: 'Pfade filtern…',
  noPaths: 'Keine passenden Pfade',
  selected: 'ausgewählt',
  confirmDeleteRestriction: 'Diese Einschränkung löschen?',
  confirmDeleteFeature: 'Dieses Feature löschen?',
  allRestrictions: 'Alle Nutzungseinschränkungen',
  seeAllRestrictions: 'Alle anzeigen',
  seeUsageRestrictions: 'Nutzungseinschränkungen anzeigen',
  filteredByFeature: 'Gefiltert nach Feature',
  feature: 'Feature',
  features: 'Features',
  selectFeatures: 'Features suchen...',
  combinedLimitHint: 'Das Limit gilt als ein gemeinsames Kontingent über alle gewählten Features.',
  selectTier: 'Tier auswählen...',
  existingRuleConflict:
    'Für diese Kombination existiert bereits eine Regel. Bearbeiten Sie sie, um Änderungen vorzunehmen.',
  editExisting: 'Bestehende bearbeiten',
  featureInUseToast:
    'Features, die in Restriktionen verwendet werden, können nicht gelöscht werden',
  restrictionConflictToast:
    'Für dieses Feature in diesem Scope existiert bereits eine Einschränkung.',
  type: 'Typ',
  platformWide: 'Plattformweit',
  kpiTotalOrgs: 'Organisationen',
  kpiCritical: 'Kritisch',
  kpiCriticalDesc: '≥ 90%',
  kpiWarning: 'Warnung',
  kpiWarningDesc: '50–89%',
  kpiHealthy: 'Unkritisch',
  kpiHealthyDesc: '< 50%',
  override: 'Überschreiben',
  overridden: 'Überschrieben',
  addOverrideTitle: 'Überschreibung hinzufügen',
  editOverrideTitle: 'Überschreibung bearbeiten',
  catalog: 'Katalog',
  catalogSubtitle: 'Features und Nutzungseinschränkungen verwalten',
  manageOrga: 'Organisation verwalten',
  manageUser: 'Nutzer verwalten',
  usageRestrictions: 'Nutzung',
  featureRestrictions: 'Features',
  pathRestrictions: 'Pfade',
  searchRestrictions: 'Einschränkungen suchen...',
  searchEndpoints: 'Endpoints suchen...',
  searchFeatures: 'Features suchen...',
  refresh: 'Aktualisieren',
  method: 'Methode',
  allMethods: 'Alle Methoden',
  endpoint: 'Endpoint',
  description: 'Beschreibung',
  name: 'Name',
  actions: 'Aktionen',
  createFeature: 'Feature erstellen',
  createFirstRestriction: 'Erste Einschränkung erstellen',
  createFirstFeature: 'Erstes Feature erstellen',
  noFeaturesFound: 'Keine Features gefunden',
  loadingFeatures: 'Features werden geladen...',
  noDescription: 'Keine Beschreibung',
  noFeatureLinked: 'Kein Feature verknüpft',
  showingFeatures: 'Zeige {shown} von {total} Features'
}
